/**
 * Cache Configuration
 *
 * Centralized configuration for image caching behavior.
 * Adjust these values based on your performance requirements and user base.
 */

export const CACHE_CONFIG = {
  // Memory Cache (In-Session)
  memory: {
    // Maximum cache size in bytes (100MB)
    maxSize: 100 * 1024 * 1024,

    // Time-to-live for cached images in milliseconds (10 minutes)
    ttl: 10 * 60 * 1000,

    // Cleanup interval in milliseconds (1 minute)
    cleanupInterval: 60 * 1000,

    // Cache eviction target (evict to 80% capacity when full)
    evictionTarget: 0.8,
  },

  // Service Worker Cache (Persistent)
  serviceWorker: {
    // Cache version (increment to invalidate old caches)
    version: 'v1',

    // Maximum number of cached images
    maxEntries: 150,

    // Time before cached images are considered expired (24 hours)
    expiryTime: 24 * 60 * 60 * 1000,

    // Cache eviction target (evict to 80% capacity when full)
    evictionTarget: 0.8,
  },

  // Image patterns to cache
  imagePatterns: [
    /\/media\/thumbnail\.webp$/,
    /\/media\/preview\//,
    /\.(jpg|jpeg|png|gif|webp|svg)$/i,
  ],

  // Preloading behavior
  preloading: {
    // Enable automatic thumbnail preloading on page load
    enabled: true,

    // Maximum number of images to preload at once
    batchSize: 20,

    // Delay before starting preload (to prioritize visible content)
    delay: 500,
  },
} as const;
